import React from 'react';
import { observer } from 'mobx-react';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { applyText, cancelText } from '../../../../../../constants/common-labels.constants';
import { AttendeeMappingFormViewModel } from './attendee-mapping-form.viewmodel';
import { CurrentMappingSection } from './attendee-mapping-current-section';
import { ContactSearchSection } from './attendee-mapping-search-section';
import './attendee-mapping-form.scss';

export type AttendeeMappingFormProps = {
    accountId: number;
    eventId: number;
    attendeeId: number;
    contactId: number | null;
    onMappingUpdated?: (contactId: number | null) => void;
};

const AttendeeMappingFormPresentation = observer(({ vm }: { vm: AttendeeMappingFormViewModel }) => (
    <CommonPopupBodyFooterLayout
        body={
            <form className='oe-form attendee-mapping-form'>
                <div className='oe-form__body'>
                    {vm.shouldShowSearch ? <ContactSearchSection vm={vm} /> : <CurrentMappingSection vm={vm} />}
                </div>
            </form>
        }
        footer={
            <div className='buttons-block buttons-block--from-right'>
                <DefaultCloseSubWindowButton
                    text={applyText()}
                    modifier={['fat', 'confirm-safe']}
                    onClick={vm.apply}
                    disabled={vm.saving || !vm.hasChanges()}
                />
                <DefaultCloseSubWindowButton text={cancelText()} />
            </div>
        }
    />
));

export const AttendeeMappingForm = withViewModel(
    AttendeeMappingFormPresentation,
    async (props: AttendeeMappingFormProps) => {
        const vm = new AttendeeMappingFormViewModel(
            props.accountId,
            props.eventId,
            props.attendeeId,
            props.contactId,
            props.onMappingUpdated,
        );
        await vm.initialize();
        return vm;
    }
);
